'use client'

import { Tag } from '@/redux/services/tagsApi'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/redux/store'
import { setMaterialsFilterTags, setNewsFilterTags } from '@/redux/features/filterSlice'
import { usePathname } from 'next/navigation'

interface Props {
    searchOpen?: Boolean,
    list: Tag[]
}

const FilterTags: React.FC<Props> = ({ searchOpen, list }) => {
    const pathname = usePathname()
    const dispatch = useDispatch()
    const { newsFilterTags, materialsFilterTags } = useSelector((state: RootState) => state.filter)

    const toggleTag = (incomingId: number) => {
        if (pathname.includes('/news')) {
            const findTag = newsFilterTags.find((id) => id === incomingId)
            if (findTag) {
                dispatch(setNewsFilterTags(newsFilterTags.filter((id) => id !== incomingId)))
            } else {
                dispatch(setNewsFilterTags([...newsFilterTags, incomingId]))
            }
        }
        if (pathname.includes('/useful-materials')) {
            const findTag = materialsFilterTags.find((id) => id === incomingId)
            if (findTag) {
                dispatch(setMaterialsFilterTags(materialsFilterTags.filter((id) => id !== incomingId)))
            } else {
                dispatch(setMaterialsFilterTags([...materialsFilterTags, incomingId]))
            }
        }
    }

    


    return (
        <div className={`filter__tags ${searchOpen && 'filter__tags_hidden'}`}>
            {list && list?.map((tag) => (
                <button
                    key={tag.id}
                    onClick={() => toggleTag(tag.id)}
                    className={newsFilterTags.find(filterTag => filterTag === tag.id) || materialsFilterTags.find(filterTag => filterTag === tag.id) ?
                        "filter__tags-item filter__tags-item_selected" :
                        "filter__tags-item"
                    }>
                    {tag.title}
                </button>
            ))}
        </div>
    )
}

export default FilterTags
